<template>
    <div>
        <!-- Table Container Card -->
        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Per Page -->
                    <b-col
                        cols="12"
                        md="2"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                        <label>Show</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>entries</label>
                    </b-col>

                    <b-col
                        cols="12"
                        md="4"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>

                    <!-- Search -->
                    <b-col cols="12" md="6">
                        <div
                            class="d-flex align-items-center justify-content-end"
                        >
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />

                            <!-- <b-dropdown
                text="Export As"
                variant="gradient-success"
              >
                <b-dropdown-item @click="recruitmentListPDF()"><feather-icon icon="FileTextIcon" /> PDF</b-dropdown-item>
                <b-dropdown-item @click="recruitmentListExcel()"> <feather-icon icon="LayoutIcon" />  Excel</b-dropdown-item>
              </b-dropdown> -->
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-col cols="12" md="12">
                <b-table
                    ref="refReqActiveListTable"
                    class="position-relative"
                    :items="fetchActiveRequisitions"
                    sticky-header="500px"
                    responsive
                    :fields="tableColumns"
                    primary-key="id"
                    :sort-by.sync="sortBy"
                    show-empty
                    empty-text="No matching records found"
                    :sort-desc.sync="isSortDirDesc"
                >
                    <template #cell(sl)="data"> {{ ++data.index }} </template>

                    <template #cell(type)="data">
                        {{ data.item.type.split("\\").pop() }}
                    </template>
                    <template #cell(title)="data">{{
                        JSON.parse(data.item.data).notification_title
                    }}</template>
                    <template #cell(details)="data">
                        <span
                            v-if="JSON.parse(data.item.data).notification_body"
                            v-html="
                                JSON.parse(
                                    data.item.data,
                                ).notification_body.replace(
                                    'Please click the following url :',
                                    '',
                                )
                            "
                        >
                        </span>
                    </template>
                    <template #cell(date)="data">
                        {{ data.item.created_at | formatDate }}
                    </template>
                    <template #cell(status)="data">
                        <span v-if="data.item.read_at">
                            <b-badge variant="light-success"
                                >Already Read</b-badge
                            >
                        </span>
                        <span v-else>
                            <b-badge variant="light-info">Not Read</b-badge>
                        </span>
                    </template>
                    <template #cell(actions)="data">
                        <b-button
                            v-if="JSON.parse(data.item.data).notification_url"
                            variant="info"
                            @click="
                                readNotification(
                                    data.item.id,
                                    JSON.parse(data.item.data).notification_url,
                                )
                            "
                            class="mr-1"
                            >Go</b-button
                        >
                    </template>
                </b-table>

                <b-modal
                    id="modal-select2"
                    title="Requisition Change Status"
                    ok-title="Submit"
                    size="sm"
                    cancel-variant="danger"
                    ok-variant="success"
                    ref="my-modal"
                    @hidden="resetModal"
                    @ok="handleOk"
                >
                    <validation-observer ref="changeStatus">
                        <b-form
                            @submit.stop.prevent="employeeListImport($event)"
                        >
                            <div>
                                <p>Requisition No: {{ form.requisition_no }}</p>
                                <b-form-group>
                                    <validation-provider
                                        name="Requisition Status"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-group
                                            label-for="Requisition Status"
                                            class="mb-2"
                                            ><label>Requisition Status</label>
                                            <v-select
                                                :reduce="
                                                    (status) => status.value
                                                "
                                                name="status"
                                                v-model="form.status"
                                                :options="statusOptions"
                                                placeholder="Change Status"
                                            />
                                        </b-form-group>
                                        <span class="text-danger"
                                            ><small>{{
                                                errors[0]
                                            }}</small></span
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <br /><br /><br /><br /><br />
                            </div>
                        </b-form>
                    </validation-observer>
                </b-modal>

                <div class="mx-2 mb-2">
                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            class="d-flex align-items-center justify-content-center justify-content-sm-start"
                        >
                            <span class="text-muted"
                                >Showing {{ dataMeta.from }} to
                                {{ dataMeta.to }} of
                                {{ dataMeta.of }} entries</span
                            >
                        </b-col>
                        <!-- Pagination -->
                        <b-col
                            cols="12"
                            sm="6"
                            class="d-flex align-items-center justify-content-center justify-content-sm-end"
                        >
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRecruitments"
                                :per-page="perPage"
                                first-number
                                last-number
                                class="mb-0 mt-1 mt-sm-0"
                                prev-class="prev-item"
                                next-class="next-item"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-card>
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BFormGroup,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BForm,
    BFormFile,
    BMediaBody,
    BModal,
    VBModal,
    BCardText,
} from "bootstrap-vue";
import { BTabs, BTab } from "bootstrap-vue";
import vSelect from "vue-select";
// import store from '@/store'
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import NotificationListFilters from "./NotificationListFilters.vue";

import useActiveNotificationList from "./useActiveNotificationList";
import notificationStoreModule from "./notificationStoreModule";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        NotificationListFilters,
        BTabs,
        BCardText,
        BTab,
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BLink,
        BFormGroup,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BForm,
        BFormFile,
        BMediaBody,
        BModal,
        VBModal,
        BCardText,
        ValidationProvider,
        ValidationObserver,
        vSelect,
    },
    data() {
        return {
            form: {
                selectedRequisitionId: "",
                requisition_no: "",
                status: "",
            },

            statusOptions: [
                { label: "Active", value: "Active" },
                { label: "Approved", value: "Approved" },
                { label: "Expired", value: "Expired" },
                { label: "Reject", value: "Reject" },
                { label: "Hired", value: "Hired" },
                { label: "Completed", value: "Completed" },
            ],
        };
    },
    setup() {
        // const { company_list } = getCompanyList();
        // const { function_list } = getFunctionList();
        // const { designation_list } = getDesignationList();
        // const { rank_list } = getRankList();
        // const { job_location_list } = getJobLocationList();
        // const { district_list } = getDistrictList();
        const showErrorModal = false;

        const {
            fetchActiveRequisitions,
            tableColumns,
            perPage,
            currentPage,
            totalRows,
            totalRecruitments,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refReqActiveListTable,
            refetchData,

            // UI
            // Extra Filters
            companyFilter,
            unitFilter,
            functionFilter,
            departmentFilter,
            sectionFilter,
            designationFilter,
            rankFilter,
            locationFilter,
            districtFilter,
            thanaFilter,
            statusFilter,
        } = useActiveNotificationList();

        function recruitmentListExcel() {}

        function recruitmentListPDF() {
            var requisition_ids = "";
            var query_str = "";
            refReqActiveListTable.value.localItems.forEach(
                function (requisition) {
                    requisition_ids += requisition.id + ",";
                },
            );
            requisition_ids = requisition_ids.replace(/,\s*$/, ""); // remove last comma
            var combined_str = requisition_ids + "##" + query_str + "##Active";
            //alert(combined_str)
            let post_data = { json_data: combined_str };
            this.$store
                .dispatch(
                    "notificationStore/RequisitionListDownloadPdf",
                    post_data,
                )
                .catch((err) => {
                    console.error(err);
                });
        }

        return {
            showErrorModal,
            // formData,
            recruitmentListExcel,
            recruitmentListPDF,
            // Sidebar

            fetchActiveRequisitions,
            tableColumns,
            perPage,
            currentPage,
            totalRows,
            totalRecruitments,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refReqActiveListTable,
            refetchData,

            // Filter
            avatarText,

            // Extra Filters
            companyFilter,
            unitFilter,
            functionFilter,
            departmentFilter,
            sectionFilter,
            designationFilter,
            rankFilter,
            locationFilter,
            districtFilter,
            thanaFilter,
            statusFilter,

            // company_list,
            // function_list,
            // designation_list,
            // rank_list,
            // job_location_list,
            // district_list,
        };
    },
    methods: {
        readNotification(id, url) {
            var _this = this;
            _this.$store
                .dispatch("notificationStore/readNotification", id)
                .then((res) => {
                    if (res.data) {
                        //_this.fetch_ref_data();
                        if (url) {
                            _this.$router.push({ path: url });
                        }
                    }
                });
        },

        sendInfo(data) {
            this.form.selectedRequisitionId = data.id;
            this.form.requisition_no = data.requisition_no;
        },
        resetModal() {
            this.form.selectedRequisitionId = "";
            this.form.requisition_no = "";
            this.form.status = "";
        },

        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            var _this = this;
            _this.$refs.changeStatus.validate().then((success) => {
                if (success) {
                    let loader = _this.$loading.show();
                    _this.$store
                        .dispatch(
                            "notificationStore/changeRequisitionStatus",
                            _this.form,
                        )
                        .then((response) => {
                            if (response.data.status == "success") {
                                _this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: response.data.message,
                                        //text: response.data.message,
                                        icon: "CheckIcon",
                                        variant: "success",
                                    },
                                });
                                this.refetchData();
                                loader.hide();
                            } else {
                                _this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: "Failed!",
                                        icon: "AlertTriangleIcon",
                                        variant: "danger",
                                    },
                                });
                            }
                        })
                        .catch((err) => {
                            _this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Failed!",
                                    icon: "AlertTriangleIcon",
                                    variant: "danger",
                                },
                            });
                        })
                        .finally((res) => {
                            loader.hide();
                        });
                }
            });

            // Push the name to submitted names
            //this.submittedNames.push(this.name)
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide("modal-select2");
            });
        },
        handleDelete(data) {
            this.$swal({
                title: "Are you sure?",
                text: `You are about to delete Requisition No: "${data.requisition_no}"`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("notificationStore/removeRequisition", {
                            id: data.id,
                        })
                        .then(() => {
                            this.refetchData();

                            this.$swal({
                                icon: "success",
                                title: "Deleted!",
                                text: `Requisition No: "${data.requisition_no}" was successfully deleted.`,
                                customClass: {
                                    confirmButton: "btn btn-success",
                                },
                            });
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                }
            });
        },
        SetSearchSubmitBtn(form) {
            this.refetchData();
        },
    },

    directives: {
        "b-modal": VBModal,
    },

    created() {
        var _this = this;
        if (!notificationStoreModule.isRegistered) {
            _this.$store.registerModule(
                "notificationStore",
                notificationStoreModule,
            );
            notificationStoreModule.isRegistered = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
    width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
